// The pointer's tip is the top left of its box, so a position is where it points.
.cursor {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
  transition:
    transform 900ms cubic-bezier(0.77, 0, 0.175, 1),
    opacity 300ms ease;
  will-change: transform;

  &[data-visible] {
    opacity: 1;
  }
}

// A rounded, brand-coloured arrow with a white edge: its own shape rather than the system pointer.
.pointer {
  position: absolute;
  top: -4px;
  left: -6px;
  filter: drop-shadow(0 3px 6px rgb(17 24 39 / 0.3));
  transform-origin: 6px 4px;
  transition: scale 120ms ease;
}

.pointerShape {
  fill: var(--color-primary);
  stroke: #fff;
  stroke-width: 2.2;
  stroke-linejoin: round;
}

.cursor[data-pressing] .pointer {
  scale: 0.82;
}

// A ring spreading from the tip when it presses.
.ripple {
  position: absolute;
  top: -1.25rem;
  left: -1.25rem;
  width: 2.5rem;
  height: 2.5rem;
  border: 2px solid var(--color-primary);
  border-radius: 50%;
  opacity: 0;
  scale: 0.2;
}

.cursor[data-pressing] .ripple {
  animation: ripple 600ms ease-out;
}

@keyframes ripple {
  from {
    opacity: 0.9;
    scale: 0.2;
  }

  to {
    opacity: 0;
    scale: 1;
  }
}
